
$(window).scroll(function(){
    if ($(window).scrollTop() > 10) {
      	$('#navibarer').removeClass('heightnavbar');
      	$('.navbar-text').removeClass('marginbig');
      	$('.navlinks').removeClass('paddingbig');
      	$('.navbar-brand').removeClass('navbrandbig');
      	$('.basket').removeClass('basketlarge');
        $('#navibarer').addClass('heightnavbarscroll');
      	$('.navbar-text').addClass('marginsmall');
      	$('.navlinks').addClass('paddingsmall');
      	$('.navbar-brand').addClass('navbrandsmall');
      	$('.basket').addClass('basketsmall');
      
    }
    else {
        $('#navibarer').removeClass('heightnavbarscroll');
      	$('.navbar-text').removeClass('marginsmall');
      	$('.navlinks').removeClass('paddingsmall');
      	$('.navbar-brand').removeClass('navbrandsmall');
      	$('.basket').removeClass('basketsmall');
      	$('#navibarer').addClass('heightnavbar');
      	$('.navbar-text').addClass('marginbig');
      	$('.navlinks').addClass('paddingbig');
      	$('.navbar-brand').addClass('navbrandbig');
      	$('.basket').addClass('basketlarge');
    }
});



$(document).ready(function(){
  $('.dropdown-link').hover(function(){
    $('.dropdown-menu').fadeIn('fast').addClass('displayon');
  });
});

$(document).mouseup(function (e) {
    var container = $(".dropdown-menu");
    if (container.has(e.target).length === 0){
        $(".dropdown-menu").fadeOut("fast").removeClass("displayon");
    }
});
